aha-record-icon {
  margin-right: 0.3em;
}
